import React from 'react'
import ReactDOM from 'react-dom'
import {Provider} from 'react-redux'
import {createStore, applyMiddleware} from 'redux'
import {Router, browserHistory} from 'react-router'
import reduxThunk from 'redux-thunk'
import routes from './routes'
import reducers from './reducers'
import {AUTH_USER} from './actions/types'
import './index.css'
import 'react-widgets/dist/css/react-widgets.css'

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore)
const store = createStoreWithMiddleware(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
)

const token = localStorage.getItem('token') // if token user signed in
if (token) {
  // so update state
  store.dispatch({type: AUTH_USER})
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory}>
      {routes}
    </Router>
  </Provider>,
  document.getElementById('root'),
)



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/